module.exports = __webpack_public_path__ + "img/icon-badge.3b72725d.svg";